(function () {'use strict';}());
angular.module('app').service('AppService', function($http,$filter,$window)
{
	var trace = angular.trace;
	var lookup = {};
	var listing = [];
	var self = {};

	self.assessmentResults = [];

	self.authenticate = function(pin){
		return $http.post('php/services/AppService.php',{request:"authenticate",pin:pin.toLowerCase()}).error(onConnectionFailure);
	};

	self.loadAppContent = function(){
		return $http.post('php/services/AppService.php',{request:"load"}).success(onAppContentLoad).error(onConnectionFailure);
	};

	self.saveUserResponseForAssessment = function(question, isLastQuestion){
		return $http.post('php/services/AppService.php',{request:"saveAssessmentResponse",questionID: question.id, isLastQuestion: isLastQuestion, response: question.userResponse.value.toString()}).success(updateBadges).error(onConnectionFailure);
	};

	self.saveUserResponseForReflection = function(reflection){
		trace("saving", reflection);
		return $http.post('php/services/AppService.php',{request:"saveReflectionResponse", goalID: reflection.goalID,cgid: reflection.cgid,response:reflection.userResponse.id || "0"}).success(updateBadges).error(onConnectionFailure);
	};

	self.logout = function() {
		return $http.post('php/services/AppService.php',{request:"logout"}).success(function(){
			$window.location.reload();
		}).error(onConnectionFailure);
	};

	self.getIdForWeek = function(week){
		for(var i = 0, count = self.assessmentResults.length; i < count; i++){
			var question = self.assessmentResults[i];
			if(week === question.week) return question.assessmentID;
		}
		return null;
	};
	self.getWeekForId = function(id){
		for(var i = 0, count = self.assessmentResults.length; i < count; i++){
			var question = self.assessmentResults[i];
			if(id === question.assessmentID) return question.week;
		}
		return null;
	};

	function updateBadges(result) {
		self.badges = result.badges;
	}


	function onAppContentLoad(result)
	{
		storeAssessmentResults(result.assessmentResults.current,result.assessment,result.assessmentResults);

		self.contacts = result.contacts;
		self.messages = result.messages;
		self.feedback = result.assessment.feedback;
		self.badges = result.badges;
		storeReflectionResults(result);
		trace(result,"-----------");
	}

	function storeReflectionResults(result)
	{
		self.reflectionImages = result.reflection.images;
		self.reflectionResponses = result.reflection.responses;
		self.reflectionSelections = result.reflection.selections;
		self.reflectionUserResponses = result.reflection.userResponses;

		for(var i = 0, count = self.reflectionSelections.length; i < count; i++)
		{
			var selection = self.reflectionSelections[i];
			selection.userResponse = fetchResponse(selection,result.reflection.userResponses);
		}
	}

	function fetchResponse(selection,responses){
		for(var i = 0, count = responses.length; i < count; i++)
		{
			var response = responses[i];
			if(response.cgid === selection.cgid) return response.response;
		}
		return null;
	}

	function storeAssessmentResults(assessmentID,assessment,result)
	{
		self.currentAssessmentID = assessmentID;
		self.assessmentResults = result.responses;
		self.assessmentData = assessment;
		self.updateAssessmentData(assessmentID,assessment,result);
	}

	function onConnectionFailure(error)
	{
		$window.location.reload();
	}
	function cleanQuestions()
	{
		var questions =  self.assessmentData.questions;
		for(var i = 0, count = questions.length; i < count; i++)
		{
			var question = questions[i];
			question.userResponse =  null;
		}
	}
	self.updateAssessmentData = function(assessmentID){
		var currentResponses = $filter('response')(self.assessmentResults,assessmentID);
		var i,count,item,question;


		cleanQuestions();

		for(i = 0, count = currentResponses.length; i < count; i++)
		{
			item = currentResponses[i];
			question = self.assessmentData.questions[item.questionID - 1]; //todo fix this
			question.userResponse = item.response;
		}
		for(i = 0, count = self.assessmentResults.length; i < count; i++)
		{
			item = self.assessmentResults[i];
			question = self.assessmentData.questions[item.questionID - 1];
			question.assessmentID = item.assessmentID;
			question.week = item.week;
			item.type = question.type; 
			item.scale = question.scale;
		}

		if(question) self.currentAssessmentWeek = question.week;
	};


	return self;
});